import React from 'react';

const ProductListItem = ({ product, onClick, hasTransferRequest = false, hasConfirmedRequest = false }) => {
  const formatDate = (dateString) => {
    if (!dateString) return 'Не указано';
    return new Date(dateString).toLocaleDateString('ru-RU', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
  };

  const handleCardEnter = (e) => {
    const el = e.currentTarget;
    el.style.borderColor = '#2d5a3d';
    el.style.transform = 'translateY(-2px)';
    el.style.boxShadow = '0 8px 20px rgba(0, 0, 0, 0.3)';
  };

  const handleCardLeave = (e) => {
    const el = e.currentTarget;
    el.style.borderColor = '#1a472a';
    el.style.transform = 'translateY(0)';
    el.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.2)';
  };

  return (
    <div
      className="masonry-item lm-product-card"
      onClick={onClick}
      onMouseEnter={handleCardEnter}
      onMouseLeave={handleCardLeave}
      style={{
        background: '#1c1f22',
        borderRadius: 12,
        boxShadow: '0 6px 20px rgba(0, 0, 0, 0.35)',
        border: '2px solid #1a472a',
        transition: 'transform 0.2s, box-shadow 0.2s, border-color 0.2s',
        cursor: 'pointer',
        display: 'flex',
        flexDirection: 'column',
        position: 'relative',
        overflow: 'hidden',
        height: 'auto',
        alignSelf: 'flex-start',
        width: '100%'
      }}
    >
      {(hasTransferRequest || hasConfirmedRequest) && (
        <div
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            height: 4,
            background: hasConfirmedRequest
              ? 'linear-gradient(90deg, #1890ff, #40a9ff)'
              : 'linear-gradient(90deg, #ff8c00, #ffa500)',
            zIndex: 10
          }}
        />
      )}

      {(hasTransferRequest || hasConfirmedRequest) && (
        <div
          style={{
            position: 'absolute',
            top: 8,
            right: 8,
            width: 24,
            height: 24,
            background: hasConfirmedRequest ? '#1890ff' : '#ff8c00',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 10,
            boxShadow: hasConfirmedRequest
              ? '0 2px 8px rgba(24, 144, 255, 0.4)'
              : '0 2px 8px rgba(255, 140, 0, 0.4)',
            border: '2px solid white'
          }}
        >
          <span style={{ color: 'white', fontSize: 14, fontWeight: 'bold' }}>
            {hasConfirmedRequest ? '✓' : '!'}
          </span>
        </div>
      )}

      <div
        style={{
          width: '100%',
          aspectRatio: '1 / 1',
          background: '#0f1113',
          position: 'relative',
          overflow: 'hidden',
          flexShrink: 0
        }}
      >
        {product.photoUrl ? (
          <img
            src={product.photoUrl}
            alt={product.name}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              objectPosition: 'center',
              display: 'block'
            }}
          />
        ) : (
          <div
            style={{
              color: '#6b7280',
              fontSize: 14,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              height: '100%',
              width: '100%'
            }}
          >
            Нет фото
          </div>
        )}
      </div>

      <div
        style={{
          padding: 16,
          display: 'flex',
          flexDirection: 'column',
          gap: 8,
          flexShrink: 0
        }}
      >
        <h3
          style={{
            margin: 0,
            fontSize: 16,
            color: '#e8e8e8',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
          }}
        >
          {product.name}
        </h3>

        <div style={{ fontSize: 14, color: '#b5b9bf', lineHeight: 1.4 }}>
          <div>Серийный номер: {product.serialNumber || 'Не указан'}</div>
          <div>Идентификационный номер: {product.identificationNumber || 'Не указан'}</div>
        </div>

        <div
          style={{
            display: 'inline-block',
            alignSelf: 'flex-start',
            background: '#1a472a',
            color: 'white',
            padding: '4px 8px',
            borderRadius: 4,
            fontSize: 12,
            fontWeight: 'bold'
          }}
        >
          {product.status}
        </div>

        <div style={{ fontSize: 14, color: '#b5b9bf', lineHeight: 1.4 }}>
          <div>Вы — владелец №{product.ownerNumber || 1}</div>
          <div>Дата закрепления: {formatDate(product.assignedAt)}</div>
        </div>

        <button
          type="button"
          style={{
            width: '100%',
            background: '#1a472a',
            color: 'white',
            border: 'none',
            padding: 12,
            borderRadius: 8,
            cursor: 'pointer',
            fontSize: 14,
            fontWeight: 500,
            marginTop: 4,
            boxShadow: '0 2px 8px rgba(26, 71, 42, 0.35)'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.background = '#2d5a3d';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background = '#1a472a';
          }}
        >
          Подробнее
        </button>
      </div>
    </div>
  );
};

export default ProductListItem;
